<template lang="pug">
  .mr-calendar.clearfix
    .year-month-wrap.xs-12
      .xs-2.text-left
        span.arrow.icon-arrow-back.clickable.color-purple(@click="previousMonth" :class="{'arrow-disabled': previousMonthDisabled}")
      .xs-8.text-center
        p.month-year.upper {{monthText}} {{selectedYear}}
      .xs-2.text-right
        span.arrow.icon-arrow-forward.clickable.color-purple(@click="nextMonth" :class="{'arrow-disabled': nextMonthDisabled}")

    .week-wrap.xs-12.text-center
      .week-day-header
        p.week-day SUN
      .week-day-header
        p.week-day MON
      .week-day-header
        p.week-day TUE
      .week-day-header
        p.week-day WED
      .week-day-header
        p.week-day THU
      .week-day-header
        p.week-day FRI
      .week-day-header
        p.week-day SAT

    .day-wrap.xs-12
      .calendar-box(v-for="day in calendarDays" @click="update(day)" :class="{closed: day.closed, selected: day.date && day.date == value}" data-mr-ass="calendar-date")
        p.day.xs-f-xsmall.lg-f-small.max-at-tweak(:class="{ninja: !day.day}") {{day.day}}

</template>

<script>

  export default {
    data() {
      return {
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        numBoxes: 42,
        currentDate: null,
        selectedYear: null,
        selectedMonth: null,
        selectedDay: null
      }
    },

    props: {
      value: {
        type: [Date, String]
      },
      startDate: {
        type: String
      },
      minDate: {
        type: [Date, String]
      },
      maxDate: {
        type: [Date, String]
      },
      disabledDates: {
        type: Array,
        default: function() {
          return [];
        }
      }
    },

    watch: {
      value: function(newVal, oldVal) {
        let newDateVal = new Date(newVal);
        this.selectedDay = newDateVal.getDate();
        this.selectedYear = newDateVal.getFullYear();
        this.selectedMonth = newDateVal.getMonth();
        this.currentDate = newDateVal;
      }
    },

    computed: {
      monthText() {
        return this.months[this.selectedMonth];
      },

      daysInSelectedMonth() {
        return new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate();
      },

      weekdayOfTheFirst() {
        return new Date(this.selectedYear, this.selectedMonth, 1).getDay();
      },

      calendarDays() {
        var days = [];

        for (var x = 0; x < this.numBoxes; x++) {
          var day = {
            day: 0,
            date: null,
            closed: true
          };

          if (x < this.weekdayOfTheFirst || x > (this.daysInSelectedMonth + this.weekdayOfTheFirst - 1)) {
            days.push(day);
          } else {
            day.day = x - this.weekdayOfTheFirst + 1;
            day.date = new Date(this.selectedYear, this.selectedMonth, x - this.weekdayOfTheFirst + 1).toISOString();
            day.closed = !this.inDateRange(day.date) || this.isDisabledDate(day.date);

            days.push(day);
          }
        }

        return days;
      },

      previousMonthDisabled() {
        var testDate = new Date(this.selectedYear, this.selectedMonth, 0);
        return !this.inDateRange(testDate);
      },

      nextMonthDisabled() {
        var testDate = new Date(this.selectedYear, this.selectedMonth + 1, 1);
        return !this.inDateRange(testDate);
      }
    },

    methods: {
      update(day) {
        if (day.day && !day.closed && (!this.isSelectedDay(day))) {
          this.selectedDay = day.day;
          this.$emit('input', day.date);
        }
      },

      inDateRange(date) {
        var start = this.minDate ? new Date(this.minDate) : null;
        var end = this.maxDate ? new Date(this.maxDate) : null;
        var cmp = new Date(date);
        var cmpYear = cmp.getFullYear();
        var cmpMonth = cmp.getMonth();
        var cmpDate = cmp.getDate();

        var earlierThanStart = false;
        var laterThanEnd = false;

        if (start) {
          var startYear = start.getFullYear();
          var startMonth = start.getMonth();
          var startDate = start.getDate();

          if (cmpYear < startYear) {
            earlierThanStart = true;
          } else if (cmpYear == startYear && cmpMonth < startMonth) {
            earlierThanStart = true;
          } else if (cmpYear == startYear && cmpMonth == startMonth && cmpDate < startDate) {
            earlierThanStart = true;
          }
        }

        if (end) {
          var endYear = end.getFullYear();
          var endMonth = end.getMonth();
          var endDate = end.getDate();

          if (cmpYear > endYear) {
            laterThanEnd = true;
          } else if (cmpYear == endYear && cmpMonth > endMonth) {
            laterThanEnd = true;
          } else if (cmpYear == endYear && cmpMonth == endMonth && cmpDate > endDate) {
            laterThanEnd = true;
          }
        }

        return !(earlierThanStart || laterThanEnd);
      },

      isSelectedDay(day) {
        return this.$moment(day.date).isSame(this.$moment(this.currentDate), 'day');
      },

      isDisabledDate(date) {
        var disabled = false;
        this.disabledDates.forEach(d => {
          if (d == date) {
            disabled = true;
          }
        });
        return disabled;
      },

      previousMonth() {
        if (!this.previousMonthDisabled) {
          if (this.selectedMonth == 0) {
            this.selectedYear -= 1;
            this.selectedMonth = 11;
          } else {
            this.selectedMonth -= 1;
          }
        }
      },

      nextMonth() {
        var testDate = new Date(this.selectedYear, this.selectedMonth + 1, 1);
        this.inDateRange(testDate);
        if (!this.nextMonthDisabled) {
          if (this.selectedMonth == 11) {
            this.selectedYear += 1;
            this.selectedMonth = 0;
          } else {
            this.selectedMonth += 1;
          }
        }
      }
    },

    created() {
      this.currentDate = new Date();
      if (this.value) {
        this.currentDate = new Date(this.value);
      }
      this.selectedYear = this.currentDate.getFullYear();
      this.selectedMonth = this.currentDate.getMonth();
      this.selectedDay = this.currentDate.getDate();
      
    }
  }
</script>
